import { call, put } from 'redux-saga/effects';
import { doHideLoading, doLoadedPage, doLoadingPage, doShowLoading } from '../actions/ui';
import { handleFetchPlansV2 } from './plan';
import { fetchClientBySession } from '../api/session';
import { doSaveClientMsisdn, doSaveSessionId } from '../actions/session';
import { doSaveCard } from '../actions/card';
import { push } from 'react-router-redux';

function* handleFetchClientBySession(action) {
  yield put(doShowLoading());
  yield put(doLoadingPage());
  const { sessionId, planCode } = action.payload;
  try {
    yield call(handleFetchPlansV2, { sessionId, selectedPlan: planCode });
    const headers = { headers: { 'x-api-key': process.env.REACT_APP_X_API_KEY_BFF } };
    const result = yield call(fetchClientBySession, sessionId, headers);
    const { card, msisdn } = result.data;
    yield put(doSaveSessionId(sessionId));
    yield put(doSaveClientMsisdn(msisdn));
    yield put(doSaveCard(card));
  } catch (e) {
    yield put(push('/error-v2'));
  } finally {
    yield put(doHideLoading());
    yield put(doLoadedPage());
  }
}

export { handleFetchClientBySession };
